import BellIcon from '@heroicons/react/outline/esm/BellIcon.js'
import HomeIcon from '@heroicons/react/outline/esm/HomeIcon.js'
import NewspaperIcon from '@heroicons/react/outline/esm/NewspaperIcon.js'
import SearchIcon from '@heroicons/react/outline/esm/SearchIcon.js'
import UserCircleIcon from '@heroicons/react/outline/esm/UserCircleIcon.js'
import UserGroupIcon from '@heroicons/react/outline/esm/UserGroupIcon.js'
import ViewGridIcon from '@heroicons/react/outline/esm/ViewGridIcon.js'
import BellSolidIcon from '@heroicons/react/solid/esm/BellIcon.js'
import HomeSolidIcon from '@heroicons/react/solid/esm/HomeIcon.js'
import NewspaperSolidIcon from '@heroicons/react/solid/esm/NewspaperIcon.js'
import SearchSolidIcon from '@heroicons/react/solid/esm/SearchIcon.js'
import UserCircleSolidIcon from '@heroicons/react/solid/esm/UserCircleIcon.js'
import UserGroupSolidIcon from '@heroicons/react/solid/esm/UserGroupIcon.js'
import ViewGridSolidIcon from '@heroicons/react/solid/esm/ViewGridIcon.js'

import { I18nShape } from '@tribeplatform/react-components/i18n'

import { MainMenuAction, MainMenuIcon, MainMenuItem } from './types.js'

export const mainMenuIcons = {
  [MainMenuIcon.BellIcon]: BellIcon,
  [MainMenuIcon.HomeIcon]: HomeIcon,
  [MainMenuIcon.NewspaperIcon]: NewspaperIcon,
  [MainMenuIcon.SearchIcon]: SearchIcon,
  [MainMenuIcon.UserCircleIcon]: UserCircleIcon,
  [MainMenuIcon.UserGroupIcon]: UserGroupIcon,
  [MainMenuIcon.ViewGridIcon]: ViewGridIcon,
}

export const mainMenuActiveIcons = {
  [MainMenuIcon.BellIcon]: BellSolidIcon,
  [MainMenuIcon.HomeIcon]: HomeSolidIcon,
  [MainMenuIcon.NewspaperIcon]: NewspaperSolidIcon,
  [MainMenuIcon.SearchIcon]: SearchSolidIcon,
  [MainMenuIcon.UserCircleIcon]: UserCircleSolidIcon,
  [MainMenuIcon.UserGroupIcon]: UserGroupSolidIcon,
  [MainMenuIcon.ViewGridIcon]: ViewGridSolidIcon,
}

export const mainMenuDefaultItemsFactory = (
  intl: I18nShape,
): MainMenuItem[] => {
  const { $t } = intl

  return [
    {
      enabled: true,
      label: $t({ id: 'Navigation.Home', defaultMessage: 'Home' }),
      action: MainMenuAction.OPEN_SPACE,
      icon: MainMenuIcon.HomeIcon,
      spaceSlug: 'default::home',
      link: null,
    },
    {
      enabled: true,
      label: $t({ id: 'Navigation.Members', defaultMessage: '{MEMBERS_CC}' }),
      action: MainMenuAction.OPEN_SPACE,
      icon: MainMenuIcon.UserGroupIcon,
      spaceSlug: 'default::members',
      link: null,
    },
    {
      enabled: true,
      label: $t({ id: 'Navigation.Spaces', defaultMessage: '{SPACES_CC}' }),
      action: MainMenuAction.OPEN_SPACE,
      icon: MainMenuIcon.ViewGridIcon,
      spaceSlug: 'default::spaces',
      link: null,
    },
    {
      enabled: false,
      label: $t({ id: 'Navigation.Profile', defaultMessage: 'Profile' }),
      action: MainMenuAction.OPEN_PROFILE,
      icon: MainMenuIcon.UserCircleIcon,
      spaceSlug: null,
      link: null,
    },
  ]
}
